import { routePath } from "../../routes/routePath";

export const pageInfoNews = {
  root: [
    { name: "ホームページ", url: routePath.homepage },
    { name: "お知らせ", url: routePath.news },
  ],
  pageHeader: "お知らせ",
};
